export default __webpack_public_path__ + "static/media/ImagemDaReitora.6a775aab.jpg";